/* Aurum Luxe — theme.js (vanilla, no dependencies) */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var T = window.theme || { routes: { root: '/', cart_add: '/cart/add', cart_change: '/cart/change' }, strings: {} };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '{{amount}}';
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, precision, thousands, decimal) {
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
    }
    var m = format.match(placeholder);
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2, ',', '.');
    }
    return format.replace(placeholder, value);
  }
  function priceHTML(v) {
    if (v.compare_at_price && v.compare_at_price > v.price) {
      return '<div class="price-wrap"><span class="price price--sale">' + formatMoney(v.price) + '</span> <s class="price price--compare">' + formatMoney(v.compare_at_price) + '</s></div>';
    }
    return '<div class="price-wrap"><span class="price">' + formatMoney(v.price) + '</span></div>';
  }
  window.themeFormatMoney = formatMoney;

  /* ---------- Drawers ---------- */
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var input = $('input[type=search]', d); if (input) setTimeout(function () { input.focus(); }, 300);
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.body.classList.remove('no-scroll');
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      if (opener.dataset.open === 'CartDrawer') renderCart().then(function () { openDrawer('CartDrawer'); });
      else openDrawer(opener.dataset.open);
      return;
    }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Cart ---------- */
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function updateCounts(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.classList.toggle('is-empty', count === 0); });
  }
  function renderCart() {
    return fetch(T.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCounts(cart.item_count);
        var box = $('[data-cart-items]'); var total = $('[data-cart-total]');
        if (total) total.innerHTML = formatMoney(cart.total_price);
        if (!box) return cart;
        if (!cart.items.length) { box.innerHTML = '<div class="cart-empty">' + (T.strings.empty || 'Your cart is empty') + '</div>'; return cart; }
        box.innerHTML = cart.items.map(function (item, i) {
          var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
          var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="ci__variant">' + esc(item.variant_title) + '</div>' : '';
          return '<div class="ci" data-line="' + (i + 1) + '">' +
            '<a class="ci__img" href="' + item.url + '">' + (img ? '<img src="' + img + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '') + '</a>' +
            '<div><a class="ci__title" href="' + item.url + '">' + esc(item.product_title) + '</a>' + variant +
            '<div class="ci__row"><div class="qty"><button type="button" data-line-qty="' + (item.quantity - 1) + '" aria-label="Decrease">−</button>' +
            '<input type="number" value="' + item.quantity + '" min="0" readonly aria-label="Quantity">' +
            '<button type="button" data-line-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button></div>' +
            '<strong>' + formatMoney(item.final_line_price) + '</strong></div>' +
            '<button type="button" class="ci__remove" data-line-qty="0">Remove</button></div></div>';
        }).join('');
        return cart;
      });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-qty]'); if (!b) return;
    var line = b.closest('[data-line]'); if (!line) return;
    line.style.opacity = '.5';
    fetch(T.routes.cart_change + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line.dataset.line), quantity: Number(b.dataset.lineQty) })
    }).then(renderCart);
  });

  function addToCart(form) {
    var btn = $('[type=submit]', form);
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.classList.add('is-loading'); btn.textContent = T.strings.adding || 'Adding…'; }
    return fetch(T.routes.cart_add + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return renderCart(); })
      .then(function () { openDrawer('CartDrawer'); })
      .catch(function (err) { alert((err && (err.description || err.message)) || 'Could not add to cart'); })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.innerHTML = label; } });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-ajax-cart]'); if (!f) return;
    e.preventDefault(); addToCart(f);
  });

  /* ---------- Product cards (size pills) ---------- */
  function initCards(scope) {
    $$('[data-product-card]', scope).forEach(function (card) {
      if (card.dataset.ready) return; card.dataset.ready = '1';
      var json = $('[data-variants]', card); if (!json) return;
      var variants; try { variants = JSON.parse(json.textContent); } catch (e) { return; }
      $$('[data-option-value]', card).forEach(function (pill) {
        pill.addEventListener('click', function () {
          $$('[data-option-value]', card).forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          var val = pill.dataset.optionValue;
          var v = variants.filter(function (x) { return x.option1 === val && x.available; })[0] || variants.filter(function (x) { return x.option1 === val; })[0];
          if (!v) return;
          $('input[name=id]', card).value = v.id;
          var price = $('[data-price]', card); if (price) price.innerHTML = priceHTML(v);
          var btn = $('[type=submit]', card);
          if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? (T.strings.add || 'Add to cart') : (T.strings.soldOut || 'Sold out'); }
        });
      });
    });
  }

  /* ---------- Generic sliders ---------- */
  function initSliders(scope) {
    $$('[data-slider]', scope).forEach(function (slider) {
      if (slider.dataset.ready) return; slider.dataset.ready = '1';
      var track = $('[data-track]', slider); if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var dots = $$('[data-dots] .dot', slider);
      var index = 0, timer = null;
      function step() { return slides[0] ? slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth; }
      function go(i) {
        var max = slides.length - 1;
        index = i > max ? 0 : i < 0 ? max : i;
        track.scrollTo({ left: index * step(), behavior: 'smooth' });
      }
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / step());
        if (i !== index) index = i;
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }, { passive: true });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); restart(); }); });
      var prev = $('[data-prev]', slider), next = $('[data-next]', slider);
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      var delay = Number(slider.dataset.autoplay || 0);
      function restart() { if (!delay) return; clearInterval(timer); timer = setInterval(function () { go(index + 1); }, delay); }
      if (delay && slides.length > 1) {
        restart();
        slider.addEventListener('mouseenter', function () { clearInterval(timer); });
        slider.addEventListener('mouseleave', restart);
      }
    });
  }

  /* ---------- Tabs ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tab-target]'); if (!btn) return;
    var root = btn.closest('[data-tabs]'); if (!root) return;
    $$('[data-tab-target]', root).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
    $$('[data-tab-panel]', root).forEach(function (p) { p.classList.toggle('is-active', p.id === btn.dataset.tabTarget); });
  });

  /* ---------- Read more ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-readmore-btn]'); if (!b) return;
    var box = b.previousElementSibling; if (!box) return;
    var open = box.classList.toggle('is-open');
    b.textContent = open ? 'Read less' : 'Read more';
  });

  /* ---------- Collection sort ---------- */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-sort]')) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value); url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- Main product ---------- */
  function initProduct(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var jsonEl = $('[data-product-json]', root); if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);
    var form = $('[data-product-form]', root);
    var idInput = form ? $('[data-variant-id]', form) : null;
    var atc = form ? $('[data-atc]', form) : null;
    var groups = $$('[data-option-index]', root);
    var stage = $('[data-stage]', root);
    var thumbs = $$('[data-thumbs] .gallery__thumb', root);
    var gdots = $$('[data-gallery-dots] .dot', root);
    var sticky = $('[data-sticky-atc]', root);
    var stickySelect = $('[data-sticky-select]', root);
    var stickyBtn = $('[data-sticky-btn]', root);
    var coupon = $('[data-coupon]', root);

    function goToSlide(i) { if (stage) stage.scrollTo({ left: i * stage.clientWidth, behavior: 'smooth' }); }
    function setActiveMedia(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      gdots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goToSlide(Number(t.dataset.index)); setActiveMedia(Number(t.dataset.index)); }); });
    if (stage) stage.addEventListener('scroll', function () { setActiveMedia(Math.round(stage.scrollLeft / stage.clientWidth)); }, { passive: true });

    function selected() { return groups.map(function (g) { var a = $('.pill.is-active', g); return a ? a.dataset.value : null; }); }
    function findVariant(opts) {
      return variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0];
    }
    function markAvailability() {
      if (!groups.length) return;
      var cur = selected();
      groups.forEach(function (g, gi) {
        $$('.pill', g).forEach(function (p) {
          var test = cur.slice(); test[gi] = p.dataset.value;
          var v = findVariant(test);
          p.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function applyVariant(v) {
      if (!v) { if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; } return; }
      if (idInput) idInput.value = v.id;
      $$('[data-price]', root).forEach(function (el) { el.innerHTML = priceHTML(v); });
      if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? (T.strings.add || 'Add to cart') : (T.strings.soldOut || 'Sold out'); }
      if (stickySelect) stickySelect.value = v.id;
      if (stickyBtn) stickyBtn.disabled = !v.available;
      if (coupon) {
        var pct = Number(coupon.dataset.percent || 0), el = $('[data-coupon-price]', coupon);
        if (pct && el) el.innerHTML = formatMoney(Math.round(v.price * (100 - pct) / 100));
      }
      if (v.featured_media && stage) {
        var slides = $$('.gallery__slide', stage);
        slides.forEach(function (s, i) { if (String(s.dataset.mediaId) === String(v.featured_media.id)) { goToSlide(i); setActiveMedia(i); } });
      }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      markAvailability();
    }
    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var p = e.target.closest('.pill'); if (!p) return;
        $$('.pill', g).forEach(function (x) { x.classList.toggle('is-active', x === p); });
        applyVariant(findVariant(selected()));
      });
    });
    markAvailability();

    // Quantity
    var qty = $('[data-qty]', root);
    if (qty) {
      var input = $('input', qty);
      $('[data-qty-minus]', qty).addEventListener('click', function () { input.value = Math.max(1, Number(input.value) - 1); });
      $('[data-qty-plus]', qty).addEventListener('click', function () { input.value = Number(input.value) + 1; });
    }

    // Sticky ATC
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(atc);
    }
    if (stickySelect) stickySelect.addEventListener('change', function () {
      var v = variants.filter(function (x) { return String(x.id) === stickySelect.value; })[0]; if (!v) return;
      groups.forEach(function (g, gi) { $$('.pill', g).forEach(function (p) { p.classList.toggle('is-active', p.dataset.value === v.options[gi]); }); });
      applyVariant(v);
    });
    if (stickyBtn && form) stickyBtn.addEventListener('click', function () { addToCart(form); });
  }

  /* ---------- Recommendations ---------- */
  function initRecommendations(scope) {
    $$('[data-recommendations]', scope).forEach(function (el) {
      if (el.dataset.ready || !el.dataset.url) return; el.dataset.ready = '1';
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = $('[data-recommendations]', tmp);
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initCards(el); }
      }).catch(function () {});
    });
  }

  /* ---------- Back to top ---------- */
  var btt = $('[data-back-to-top]');
  if (btt) {
    window.addEventListener('scroll', function () { btt.classList.toggle('is-visible', window.scrollY > 600); }, { passive: true });
    btt.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- Init ---------- */
  function init(scope) {
    initCards(scope); initSliders(scope); initRecommendations(scope);
    $$('[data-product]', scope).forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
